import { useQuery } from "@tanstack/react-query";
import { useEffect, useRef, useState } from "react";
import { RiSearchLine } from "react-icons/ri";
import Laoding from "../../../components/Loading";
import { getMethod } from "../../../function/helper";
import style from "./FilterCity.module.css";

function FilterCity({ setCity }) {
  const ref = useRef(false);
  const [key, seyKey] = useState("");
  const didMount = useRef(false);

  const {
    isFetching,
    data: filterCities,
    refetch: refetchSearchCity,
  } = useQuery({
    queryKey: ["city-search"],
    queryFn: () =>
      getMethod("/address/v1/search-city", {
        srcinput: key,
      }).then(res => {
        if (res && res.status === 200) {
          return res.cities;
        }
      }),
    enabled: false,
    refetchInterval: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    initialData: [],
  });

  useEffect(() => {
    if (didMount.current) {
      if (key.length < 2) return;
      const timeoutId = setTimeout(refetchSearchCity, 1500);

      return () => clearTimeout(timeoutId);
    } else didMount.current = true;
  }, [key]);

  return (
    <div className={"mt-4 pb-5  " + style.box}>
      <div className={"my-4 d-flex " + style.input}>
        <input
          type="text"
          value={key}
          onChange={e => seyKey(e.target.value)}
          ref={ref}
          placeholder="نام شهر (حداقل دو کاراکتر) ..."
        />
        <div className="d-flex justify-content-center align-items-center border-end border-2">
          <RiSearchLine />
        </div>
      </div>

      {isFetching && (
        <div className={style.boxLoading}>
          <Laoding />
        </div>
      )}

      {filterCities.length > 0 && isFetching === false && (
        <div className={style.boxLoading}>
          {filterCities.map(item => (
            <article
              key={item.id}
              onClick={() => {
                setCity(item.id);
                filterCities.length = 0;
                seyKey(() => "");
              }}
            >
              <strong>{item.faName}</strong>
              <span> - </span>
              <span>{item.province?.faName}</span>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}

export default FilterCity;
